import { Modal , Collapse } from "bootstrap";
/*
*
* JS Imports
*
* */
import MXShop from "./core/mx-shop"; 
import HeaderNav from "./app/sections/header";
import SwiperContentHighlight from "./app/sections/swiper-content-highlight";
import SwiperImageTextQuote from "./app/sections/swiper-image-text-quote";
import SwiperProducts from "./app/sections/swiper-products";
import SwiperContent from "./app/sections/swiper-content";
import ImageList from "./app/sections/image-list";
import SwiperGridBrands from "./app/sections/swiper-grid-brands";
import Categories from "./app/sections/categories";
import ProductStyles from "./app/pages/product-styles";
import SingleCategory from "./app/pages/single-category";
import Articles from "./app/pages/articles";
import HeroSection from "./app/sections/hero";
import ProductPage from "./app/pages/product-page";
import CollectionProductGrid from "./app/sections/collection-product-grid";
import BundleCart from "./app/pages/cart-page/bundle-cart";
import ProductRecommendations from "./app/sections/product-recommendations";
import ProductRelatedClosures from "./app/sections/product-related-closures";
import FreightShippingNotice from "./app/pages/cart-page/freight-shipping-notice";
import ShowField from "./app/sections/form-fields";
import CopyToClipBoard from "./app/lib/copyToClipboard";
import NavArrow from "./app/lib/nav-arrow";
import VideoModal from "./app/sections/video-modal"


/** Core Cart Functions  */
MXShop( { hasCartDrawer : false , cartAlert : true } );
/** // Core Cart Functions  */


HeaderNav();
SwiperContentHighlight();
SwiperImageTextQuote();
SwiperProducts();
SwiperContent();
SwiperGridBrands();
ImageList();
Categories();
ProductStyles();
SingleCategory();
Articles();
HeroSection();
CollectionProductGrid();
ProductRecommendations();
ProductRelatedClosures();
FreightShippingNotice();
ShowField();
CopyToClipBoard();
NavArrow();
VideoModal();
if( document.body.classList.contains('template-product') ){
    ProductPage();
};

if ( document.body.classList.contains('template-cart')) {
    BundleCart();
};